/**
 * Fills {merge_field} placeholders in a reply template. Fields with no value are left in place
 * so the person sending can see what still needs filling in, rather than sending a gap.
 */
export function fillMergeFields(template: string, values: Record<string, string | null | undefined>) {
  return template.replace(/\{([a-z_]+)\}/g, (placeholder, field: string) => {
    const value = values[field];
    return value === undefined || value === null || value === "" ? placeholder : value;
  });
}

/** First name for {buyer_first_name}: the first word of a real name, never an eBay username. */
export function buyerFirstName(fullName: string | null | undefined) {
  const first = fullName?.trim().split(/\s+/)[0];
  return first ? first.charAt(0).toUpperCase() + first.slice(1) : undefined;
}
